/* eslint-disable import/first */
process.env.NODE_OPTIONS = '--openssl-legacy-provider';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import FeedbackPage from './pages/FeedbackPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isFeedback =
  window.location.pathname === '/feedback' ||
  window.location.pathname.startsWith('/feedback/');

root.render(
  <React.StrictMode>
    {isFeedback ? (
      <FeedbackPage />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </React.StrictMode>
);

reportWebVitals();
